export class ComplaintStatusSearchResponseModel {
    constructor(data = {}) {
        this.isComplaint = data.isComplaint ?? null;
        this.complaintStatus = data.complaintStatus ?? null;
        this.complaintOutcome = data.complaintOutcome ?? null;
    }
}
